module.exports = __webpack_public_path__ + "static/avatar_david-8d2f208208fa2c8f5c83fe76bf00050b.png";